import { Reducer } from 'redux'
import { initialToastState } from './initialState'
import { ToastState, SHIFT_TOAST, PUSH_TOAST, ToastActionTypes } from './types'

const reducer: Reducer<ToastState, ToastActionTypes> = (state: ToastState = initialToastState, action: ToastActionTypes) => {
	switch (action.type) {
		case PUSH_TOAST: {
			const toasts = [...state.toasts]
			toasts.push(action.payload)
			return {
				...state, toasts
			}
		}
		case SHIFT_TOAST: {
			const toasts = [...state.toasts]
			toasts.shift()
			return {
				...state, toasts
			}
		}
		default: {
			return state
		}
	}
}

export { reducer as toastReducer }
